import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Spin, Alert, Typography, Tag } from "antd";

const { Title } = Typography;

const CustomerSubscription = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get("/subscriptions")
      .then((res) => {
        console.log(res.data);
        setSubscriptions(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load subscriptions.");
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Subscription Name",
      dataIndex: "subscription_name",
      key: "subscription_name",
    },
    {
      title: "Price",
      dataIndex: "subscription_price",
      key: "subscription_price",
      render: (price, record) => `${record.subscription_currency}${price}`,
    },
    {
      title: "Duration (days)",
      dataIndex: "subscription_duration",
      key: "subscription_duration",
    },
    {
      title: "Allowed SKU Calls",
      dataIndex: "allowed_sku_calls",
      key: "allowed_sku_calls",
      render: (calls) =>
        calls === null ? (
          <Tag color="blue">Unlimited</Tag>
        ) : (
          <Tag color="geekblue">{calls}</Tag>
        ),
    },
  ];

  return (
    <div style={{ maxWidth: "900px", margin: "40px auto" }}>
      <Title level={3} style={{ textAlign: "center", borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
        Active Subscription Plans
      </Title>

      {loading ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <Alert message={error} type="error" showIcon />
      ) : (
        <Table
          columns={columns}
          dataSource={subscriptions}
          rowKey="id"
          pagination={false}
          bordered
        />
      )}
    </div>
  );
};

export default CustomerSubscription;
